import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { Link } from '../../interfaces/link.interface';
import { AsyncPipe, NgIf } from '@angular/common';
import { DxDataGridModule } from 'devextreme-angular';
import { LinkService } from '../../services/link.service';
import { combineLatest, takeUntil } from 'rxjs';
import { SelectedCompanyService } from '../../selected-company/selected-company.service';
import { DxiColumnModule } from 'devextreme-angular/ui/nested';
import { TimezoneDatePipe } from '../../pipes/timezone_date.pipe';

@Component({
	selector: 'al-link-edit-activity',
	templateUrl: './link-edit-activity.component.html',
	styleUrls: ['./link-edit-activity.component.scss'],
	standalone: true,
	imports: [
		NgIf,
		AsyncPipe,
		DxDataGridModule,
        DxiColumnModule,
		TimezoneDatePipe
	],
})
export class LinkEditActivityComponent implements OnInit {
	@Input()
	link: Link;

	private destroy$ = new Subject<void>();

	context$ = new Subject<{}>();

	hasEndDates = false;

	constructor(private linkService: LinkService, private selectedCompanyService: SelectedCompanyService) {
	}

	ngOnInit() {
		// only appriver from link templates have end date selection
		this.hasEndDates = [12, 99].includes(this.link.fromLinkTemplateId);

		combineLatest([this.linkService.getActivityLogs(this.link.id), this.selectedCompanyService.getSelectedCompany()])
		.pipe(takeUntil(this.destroy$)).subscribe(r => {
			const dateFormat = r[1].dateFormat || 'dd/MM/yyy';
			return this.context$.next({activityLogs: r[0], dateFormat: dateFormat, dateTimeFormat: `${dateFormat} HH:mm:ss`, timezone: r[1].timezoneString || 'UTC'});
		});
	}
}
